{
  "pt-BR": {
    "action": {
      "one": "Ação",
      "other": "Ações"
    },
    "activate": "Ativar",
    "activerecord": {
      "attributes": {
        "article": {
          "kind": "Tipo",
          "title": "Título"
        },
        "article/topic": {
          "title": "Título"
        },
        "campaign": {
          "description": "Descrição",
          "name": "Nome",
          "url": "URL"
        },
        "championship": {
          "name": "Nome"
        },
        "editor": {
          "email": "E-mail",
          "promoter_role_id": "Perfil"
        },
        "enrollment": {
          "due_date": "Vencimento",
          "period": "Periodicidade",
          "status": "Status"
        },
        "evaluation_group": {
          "name": "Nome"
        },
        "evaluation_option": {
          "evaluation_group_id": "Grupo",
          "name": "Nome"
        },
        "event": {
          "end_at": "Data do Fim",
          "name": "Nome",
          "start_at": "Data de Início",
          "status": "Status",
          "total_of_comments": "Comentários",
          "total_of_votes": "Likes"
        },
        "grade": {
          "name": "Nome"
        },
        "invoice": {
          "customer_email": "E-mail Cliente",
          "customer_name": "Cliente",
          "description": "Descrição",
          "due_date": "Vencimento",
          "paid_at": "Data do Pagamento",
          "tax_cents": "Taxa",
          "total_cents": "Valor",
          "total_liquid_cents": "Total"
        },
        "level": {
          "name": "Nome"
        },
        "model": {
          "default": "Padrão",
          "group": "Grupo",
          "name": "Nome"
        },
        "nota_fiscal": {
          "data_competencia": "Data de Competência"
        },
        "payment_account": {
          "bank_account": {
            "kind": "Tipo",
            "number": "Número"
          },
          "boleto_cents": "Boleto",
          "credit_card_cents": "Crédito",
          "credit_card_description": "Nome na fatura do cartão",
          "credit_card_percent": "Crédito",
          "default": "Padrão",
          "name": "Nome",
          "person_type": "Tipo de Pessoa",
          "pix_percent": "Pix",
          "withdraw_cents": "Saque"
        },
        "payment_category": {
          "name": "Nome"
        },
        "payment_method": {
          "name": "Nome",
          "tax_amount_input_cents": "Valor na entrada",
          "tax_amount_output_cents": "Valor na saída",
          "tax_percentage_input_cents": "Porcentagem na entrada",
          "tax_percentage_output_cents": "Porcentagem na saída"
        },
        "plan": {
          "highlight": "Destaque",
          "name": "Nome"
        },
        "product": {
          "amount": "Valor",
          "featured": "Destaque",
          "name": "Nome",
          "quantity": "Quantidade",
          "sold": "Vendido",
          "visible": "Visível"
        },
        "product_option_type": {
          "presentation": "Apresentação"
        },
        "rhythm": {
          "name": "Nome",
          "parent_id": "Ritmo Pai"
        },
        "role": {
          "description": "Descrição",
          "name": "Nome"
        },
        "subscription": {
          "charge_date": "Cobrança",
          "due_date": "Vencimento",
          "end_date": "Fim da assinatura",
          "status": "Status",
          "trial_days": "Trial"
        },
        "tag": {
          "description": "Descrição",
          "name": "Nome"
        },
        "ticket_order_item": {
          "checkin": "Check-in"
        },
        "unit": {
          "name": "Nome"
        },
        "user": {
          "birthdate": "Nascimento",
          "email": "E-mail",
          "first_class_at": "Aula experimental",
          "name": "Nome"
        },
        "withdraw": {
          "amount_cents": "Valor Líquido",
          "bank_agency": "Agência",
          "bank_kind": "Tipo",
          "bank_number": "Número",
          "paying_at": "Previsão",
          "tax_cents": "Taxa",
          "total_cents": "Valor Bruto"
        }
      },
      "models": {
        "address": {
          "one": "Endereço"
        },
        "article": {
          "other": "Artigos"
        },
        "bank": {
          "one": "Banco"
        },
        "contract": {
          "one": "Contrato"
        },
        "coupon": {
          "one": "Cupom"
        },
        "credit": {
          "other": "Créditos"
        },
        "email": {
          "one": "E-mail"
        },
        "enrollment": {
          "one": "Matrícula",
          "other": "Matrículas"
        },
        "examiner": {
          "one": "Examinador",
          "other": "Examinadores"
        },
        "face": {
          "one": "Face"
        },
        "grade": {
          "one": "Turma"
        },
        "graduation": {
          "other": "Graduações"
        },
        "invoice": {
          "one": "Fatura"
        },
        "level": {
          "one": "Nível"
        },
        "message": {
          "one": "Mensagem"
        },
        "nota_fiscal": {
          "one": "Nota Fiscal"
        },
        "notification": {
          "other": "Notificações"
        },
        "order": {
          "one": "Pedido"
        },
        "payment_method": {
          "one": "Forma de Pagamento"
        },
        "period": {
          "one": "Período"
        },
        "permission": {
          "other": "Permissões"
        },
        "phone": {
          "one": "Telefone"
        },
        "plan": {
          "one": "Plano"
        },
        "profile": {
          "one": "Perfil"
        },
        "prospect": {
          "other": "Examinados"
        },
        "rhythm": {
          "other": "Ritmos"
        },
        "role": {
          "one": "Perfil"
        },
        "school_course": {
          "one": "Curso"
        },
        "student": {
          "one": "Aluno"
        },
        "subscription": {
          "one": "Assinatura",
          "other": "Assinaturas"
        },
        "tax": {
          "one": "Taxa"
        },
        "teacher": {
          "one": "Professor",
          "other": "Professores"
        },
        "ticket": {
          "one": "Ingresso",
          "other": "Ingressos"
        },
        "unit": {
          "one": "Unidade",
          "other": "Unidades"
        },
        "user": {
          "one": "Usuário"
        },
        "user_note": {
          "other": "Anotações"
        }
      }
    },
    "add_one_more": {
      "charge_card": "Cobrar no cartão",
      "invoice": "Adicionar +1 fatura"
    },
    "allowed": "Liberado",
    "amount": "Valor",
    "approved": {
      "other": "Aprovados"
    },
    "artistic_name": "Nome Artístico",
    "blocked": "Bloqueado",
    "cancel": "Cancelar",
    "cancel_at": "Cancelar em",
    "charge": {
      "verb": "Cobrar"
    },
    "checkin": {
      "back_camera": "Câmera traseira",
      "face_too_far": "Aproxime o rosto",
      "front_camera": "Câmera frontal",
      "identifying": "Identificando",
      "no_face": "Rosto não identificado",
      "one_face": "Apenas um rosto por vez",
      "quota": "Check-ins",
      "scan_error": "Erro ao identificar. Tente novamente.",
      "unlimited": "Ilimitado"
    },
    "checkout": {
      "loading_message": "A fatura está sendo processada, aguarde."
    },
    "code": "Código",
    "controller": "Controller",
    "copied": "copiado!",
    "copy_link": "Copiar link",
    "create_searched_user": "Criar usuário pesquisado",
    "created_at": {
      "female": "Criada em",
      "male": "Criado em"
    },
    "current_plan": "Plano atual",
    "cycle": {
      "one": "Ciclo"
    },
    "dancer": {
      "role": {
        "one": "Função"
      }
    },
    "dashboard": "Painel",
    "date": {
      "one": "Data"
    },
    "datepicker": {
      "format": "dd/MM/yy",
      "next_month": "Próximo mês",
      "placeholder": "__/__/__",
      "previous_month": "Mês anterior"
    },
    "default": "Padrão",
    "description": {
      "one": "Descrição"
    },
    "detail": {
      "other": "Detalhes"
    },
    "disapproved": {
      "other": "Reprovados"
    },
    "discount": {
      "one": "Desconto"
    },
    "document": {
      "one": "Documento"
    },
    "due_date": "Vencimento",
    "edit": "Editar",
    "email": "E-mail",
    "end": {
      "one": "Fim"
    },
    "enrollment": {
      "charge": {
        "confirm_charge": "Deseja mesmo fazer uma cobrança?"
      }
    },
    "evaluate": "Avaliar",
    "exam": {
      "other": "Exames"
    },
    "expires_at": "Expira em",
    "face": {
      "delete": {
        "confirm": "Deseja mesmo apagar o rosto?"
      },
      "switch_camera": "Virar câmera"
    },
    "fail": {
      "one": "Falha"
    },
    "finish_and_graduate": "Finalizar e Graduar",
    "follow": {
      "one": "Conduzido",
      "other": "Conduzidos"
    },
    "graduation": {
      "profile": {
        "not_selected": "Perfil não selecionado"
      },
      "role": {
        "not_selected": "Função não selecionada"
      }
    },
    "gridy": {
      "errors": {
        "record_not_found": "Nenhum resultado."
      },
      "page": {
        "button": {
          "back": "< página anterior",
          "next": "próxima página >",
          "title": "Página"
        }
      },
      "refresh": {
        "title": "Recarregar"
      },
      "search": {
        "label": "Texto da consulta",
        "placeholder": "Digite aqui o que procura"
      },
      "status": {
        "full": "Página {from} de {to} | {total} registros",
        "one": "1 registro encontrado",
        "other": "{total} registros encontrados",
        "zero": ""
      }
    },
    "gross": "Bruto",
    "highlight": "Destaque",
    "id": "ID",
    "invoice": {
      "charge": {
        "confirm": "Cobrar esta fatura no cartão de crédito do aluno ?"
      },
      "statuses": {
        "refunded": "Reembolsada"
      },
      "tip": {
        "refunded": "Reembolsada: %{comment}"
      }
    },
    "kind": {
      "one": "Tipo"
    },
    "lead": {
      "one": "Condutor",
      "other": "Condutores"
    },
    "liquid": "Líquido",
    "menu": {
      "one": "Menu"
    },
    "method": "Método",
    "mock": {
      "other": "Simulados"
    },
    "months": {
      "short": {
        "abr": "Abr",
        "ago": "Ago",
        "dez": "Dez",
        "fev": "Fev",
        "jan": "Jan",
        "jul": "Jul",
        "jun": "Jun",
        "mai": "Mai",
        "mar": "Mar",
        "nov": "Nov",
        "out": "Out",
        "set": "Set"
      }
    },
    "move": {
      "down": "Mover para baixo",
      "up": "Mover para cima",
      "verb": "Movimentar"
    },
    "name": "Nome",
    "no_result": "Nenhum resultado",
    "not_found": {
      "female": "Não encontrada",
      "male": "Não encontrado"
    },
    "nota_fiscal": {
      "cancel": {
        "confirm": "Tem certeza que deseja cancelar a nota fiscal?",
        "verb": "Cancelar Nota Fiscal"
      },
      "create": {
        "confirm": "Tem certeza que deseja emitir a nota fiscal?",
        "short": "Emitir",
        "verb": "Emitir Nota Fiscal"
      },
      "show": {
        "verb": "Ver Nota Fiscal"
      }
    },
    "notify": "Notificar",
    "order": {
      "cancel": {
        "confirm": "Tem certeza que deseja cancelar este pedido?"
      },
      "charge_failure_prefix": "Falha na cobrança",
      "schedule_cancel": {
        "confirm": "Tem certeza que deseja agendar o cancelamento?"
      }
    },
    "pagarme": "Pagar.me",
    "paid_at": "Pago em",
    "payment_method": {
      "short": "Método"
    },
    "pending": {
      "other": "Pendentes"
    },
    "percentage": {
      "one": "Porcentagem"
    },
    "push_notification": {
      "confirm_question": "Para uma experiência completa, iremos te pedir permissão para notificações.",
      "denied_message": "Notificações desabilitada, para habilitar autorize no seu navegador.",
      "manual_revoking": "É necessário remover a permissão direto no seu navegador.",
      "status": {
        "default": "Habilite as notificações para novas funcionalidades.",
        "denied": "Notificações bloqueadas. Para habilitar configure seu navegador.",
        "granted": "Notificações ativa.",
        "unsupported": "Notificações não suportada neste dispositivo/navegador/versão."
      }
    },
    "rating": {
      "hints": {
        "basic": {
          "five": "Ótimo",
          "four": "Bom",
          "one": "Péssimo",
          "three": "Regular",
          "two": "Ruim"
        },
        "evaluation": {
          "four": "Ótimo",
          "one": "Motivo da reprovação",
          "three": "Bom",
          "two": "Treinar"
        }
      },
      "no_rated_msg": "Nenhuma avaliação ainda."
    },
    "recurrence": {
      "one": "Recorrência"
    },
    "refund": {
      "verb": "Reembolsar"
    },
    "renew": {
      "one": "Renovação automática"
    },
    "result": {
      "one": "Resultado",
      "other": "Resultados"
    },
    "show": "Visualizar",
    "show_all": "Mostrar Tudo",
    "signed": "Assinado",
    "slug": "URL",
    "start": {
      "one": "Início"
    },
    "status": "Status",
    "subscription": {
      "cancel_date": "Data de cancelamento",
      "uncancel": {
        "one": "Desfazer cancelamento"
      }
    },
    "subtotal": "Subtotal",
    "system": {
      "dashboards": {
        "index": {
          "create_checkin_confirm": "Confirma o check-in deste aluno hoje?",
          "enable_credit": "Habilitar função de créditos",
          "enrollments_not_found": "Nenhuma matrícula ativa ou atrasada encontrada.",
          "new_enrollment": "Nova matrícula",
          "new_subscription": "Nova assinatura",
          "new_subscription_disabled_tooltip": "O estudante já possui uma assinatura ativa ou atrasada.",
          "register_as_student": "Registrar como estudante",
          "subscriptions_not_found": "Nenhuma assinatura ativa ou atrasada encontrada."
        }
      },
      "evaluation_options": {
        "rating": "Avaliação de %{name}",
        "rating_scored": "Avaliação de %{name}: %{score}"
      },
      "subscriptions": {
        "form": {
          "generate_first_invoice": "Gerar primeira fatura ?",
          "generate_first_invoice_credit_card": "Realizar a primeira cobrança no cartão ?"
        }
      }
    },
    "time": {
      "one": "Horário"
    },
    "today": "Hoje",
    "total": "Total",
    "transfer": {
      "verb": "Transferir"
    },
    "user": {
      "not_student": "não é estudante nesta unidade."
    },
    "user_unit_access": {
      "denied": "O aluno precisa autorizar o acesso aos seus dados pessoais para realizar esta ação. Deseja pedir acesso agora?",
      "request": {
        "confirm": "Enviar notificação para o aluno requisitando acesso a dados pessoais?",
        "verb": "Pedir acesso"
      }
    },
    "wait": "Aguarde...",
    "whatsapp": "WhatsApp"
  }
}